/************************
  [users] reducers.js
 ************************/

import * as Actions from './actions';
import initialState from '../store/initialState';

// state状態変化させる関数を作成
export const UsersReducer = (state = initialState.users, action) => {
  switch (action.type){
    case Actions.SIGN_IN:
      return {
        ...state,
        ...action.payload
      };

    case Actions.SIGN_OUT:
      return {
        ...action.payload
      };

    default:
      return state;

  }
};